var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"number-list"},_vm._l((_vm.itemList),function(item,itemIndex){return _c('div',{key:itemIndex,staticClass:"number"},[_vm._v(" "+_vm._s(item.title)),_c('span',{staticClass:"blue-number"},[_vm._v(_vm._s(item.number))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }